import { api } from './_request';

 export const get = (data) => {
 	return (dispatch) => {
 		console.log('busqueda',data);
		dispatch({
			type: 'INVENTARIO_FISICO_LIST',
			payload: data
		});
 	}
 };
 export const enviar_factura = (correos, callback) => {
	
	return (dispatch) => {

		dispatch({ type: 'SAVE' });
  		// console.log('correos--->',correos);
		api().post('/correo_cotizacion', correos).then(function(response) {

			if(response.status === 200) {
				dispatch({ type: 'UPDATE_SUCCESS',payload: response.data.cotizacion });

				if(typeof callback === 'function')
					callback(response.data);
			}
			else {
				dispatch({ type: 'UPDATE_FAILURE' });
			}
		})
		.catch(function(error) {
			console.log('error-->',error);
			dispatch({ type: 'UPDATE_FAILURE' });
		});

	}
};

 export const actualizar_informacion = (cotizacion) => {
	return (dispatch) => {

        
		dispatch({
					type: 'UPDATE_SUCCESS',
					payload: cotizacion
				});
	}
};

 export const save = (item, callback) => {
	return (dispatch) => {

		dispatch({ type: 'SAVE' });

		api().post('/cotizacion', item).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'SAVE_SUCCESS',
					payload: response.data.factura,
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};


export const alerta = (alerta) => {
	return (dispatch) => {
		dispatch({
				type: 'SAVE_ALERTA',
				payload: alerta
			});
	}
};

export const update = (item, callback) => {
	return (dispatch) => {

        
		dispatch({ type: 'SAVE' });

		api().post(`/cotizacion/${item.id}`, item)
		.then(function(response)
		{
			if(response.status === 200)
			{
				console.log('factura action----->', response.data);
				dispatch({
					type: 'UPDATE_SUCCESS',
					payload: response.data.factura
				});
				

				if(typeof callback === 'function') callback(response.data);
			}
			else
			{
				dispatch({ type: 'SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
};

export const save_compra = (compra, callback) => {
	return (dispatch) => {

		dispatch({ type: 'SAVE' });

		api().post('compra_especial', compra).then(function(response) {

			if(response.status === 200) {

				dispatch({
					type: 'TICKET_UPDATE_FAILURE',
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'TICKET_SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'TICKET_SAVE_FAILURE' });
		});

	}
};


// WEBPACK FOOTER //
// ./src/actions/cotizacion.js